/* eslint-disable camelcase */
import React, { Component } from 'react';
import { getQueryStringVal } from 'helper/QueryString';
// import ActivityIndicator from '@lyearn-team/frontend-components/dist/Loader';
import DarkThemedLoader from 'components/DarkThemedLoader';
import { getTokensFromCode } from 'helper/refetchTokens';
import saveUserCookies from 'helper/saveUserCookies';
import cookie from 'helper/cookie';
import { LoginRedirectWrapper } from './styles';
import { isUrlSaved, getSavedUrl, removeSavedUrl } from '../../helper/urlHandler';
import request from '../../../helper/NetworkLayer';
import parseJWT from '../../../helper/parseJWT';
import { clearAllIDBStores } from '../../../helper/LearningSpaceServices/IndexedDBHelper';

function getURLParams(urlString) {
  const queryString = urlString.split('?')[1];
  if (queryString) {
    const queryParams = queryString.split('&').reduce((params, cur) => {
      const key = cur.substring(0, cur.indexOf('='));
      const value = cur.substring(cur.indexOf('=') + 1);
      params[key] = value;
      return params;
    }, {});
    return queryParams;
  }
  console.log('Invalid loginRedirect url ', urlString);
  window.location.href = '/#/login?r=INVALID_URL';
  throw new Error('Invalid loginRedirect url');
}

export default class LoginRedirect extends Component {
  handleError = (error, code) => {
    try {
      const errorObject = JSON.parse(decodeURIComponent(error).replace(/\\"/g, '"'));
      const errorCode = errorObject.code;
      switch (errorCode) {
        case 'SIGNUP_NOT_ALLOWED':
        case 'USER_NOT_EXISTS':
          window.location.href = '/#/login?r=USER_NOT_EXISTS';
          break;
        case 'TOKEN_EXPIRED':
          window.location.href = '/#/login?r=TOKEN_EXPIRED';
          break;
        case 'INVALID_SAML_RESPONSE':
          window.location.href = '/#/login?r=INVALID_SAML_RESPONSE';
          break;
        case 'USER_PENDING_STATE':
          window.location.href = '/#/company-page?code=' + code;
          break;
        default:
          window.location.href = '/#/login';
      }
    } catch (e) {
      console.log('Error during login-redirect, errorString = ', error, 'error = ', e);
      throw e;
    }
  };

  async UNSAFE_componentWillMount() {
    // IMP: Clear all IDB stores on Login
    await clearAllIDBStores();
    try {
      const queryParams = getURLParams(window.location.href);
      if (queryParams.error) {
        this.handleError(queryParams.error, queryParams.code);
        return;
      }
      window.localStorage.removeItem('user_fmo_temp_login');
      const code = queryParams.code;
      if (!code || typeof code !== 'string') {
        throw new Error('invalid code format - loginRedirect');
      }
      const subDomain =
        getQueryStringVal('cn', window.location.href) || window.location.host.split('.')[0];
      await getTokensFromCode(code, subDomain);

      const lyearn_token = cookie.get('lyearn_token');
      if (!lyearn_token) {
        throw new Error('Error in fetch authTokens response, lyearn_token not present');
      }
      const decodedToken = parseJWT(lyearn_token);
      const userId = decodedToken.user._id;

      const userResponse = await request('/graphql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          query: `{user(id: "${userId}") {pid,name,companyId,picture,email,roles}}`,
          variables: '{}'
        })
      }).then(r => r.json());

      const user = userResponse.data.user;
      saveUserCookies(
        user.pid,
        user.name,
        user.companyId,
        user.email,
        user.picture,
        user.roles || []
      );
      const redirectUrl = queryParams.redirect;
      if (redirectUrl) {
        removeSavedUrl();
      }
      window.location.href =
        (redirectUrl && decodeURIComponent(redirectUrl)) ||
        (isUrlSaved() ? getSavedUrl(true) : '/#/');
    } catch (error) {
      console.log('Error in fetching/saving tokens', error);
      window.bugsnagClient && window.bugsnagClient.notify(error);
      window.location.href = '/#/login';
    }
  }

  render() {
    return (
      <LoginRedirectWrapper>
        <DarkThemedLoader />
      </LoginRedirectWrapper>
    );
  }
}
